export const app = {
	dev: process.env.NODE_ENV !== 'production',
	staging: process.env.NEXT_PUBLIC_IS_STAGING === 'true',
	host: process.env.NEXT_PUBLIC_API_HOST,
	reactQueryDevtools: process.env.NEXT_PUBLIC_REACTQUERYDEVTOOLS === '1',
	featureFlagHost: process.env.NEXT_PUBLIC_FEATURE_FLAG_HOST,
	nexus: {
		host: process.env.NEXT_PUBLIC_NEXUS_HOST,
		apiKey: process.env.NEXT_PUBLIC_NEXUS_API_KEY,
	},
	map: {
		defaultPosition: {
			latitude: 0,
			longitude: 0,
		},
	},
};
